import type { NewsItem } from "@/types/media";

export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "2026 年春节档票房再创纪录，多部影片表现亮眼",
    category: "行业动态",
    cover: "https://readdy.ai/api/search-image?query=a%20cinematic%20movie%20theater%20with%20a%20glowing%20screen%20and%20audience%20silhouettes%2C%20warm%20ambient%20light%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-01&orientation=landscape",
    summary: "今年春节档总票房刷新历史同期纪录，科幻、喜剧、动画多类型影片共同拉动大盘，观众观影热情持续高涨。",
    content: [
      "据最新统计，今年春节档总票房刷新历史同期纪录，多部影片在口碑与票房上实现双丰收。其中科幻与合家欢题材表现尤为突出，成为拉动大盘的主要力量。",
      "业内人士分析，票房的增长不仅得益于影片质量的整体提升，也与影院设施升级、观影体验优化密切相关。越来越多观众选择在节假日走进影院，与家人朋友共享光影时光。",
      "随着档期的持续升温，多部影片宣布延长放映周期。业内预计，本轮观影热潮有望延续至整个春季，为全年电影市场打下良好基础。",
    ],
    author: "麻豆影视观察",
    publishedAt: "2026-10-13",
    tags: ["票房", "春节档", "行业"],
    relatedMediaId: "movie-05",
  },
  {
    id: "news-02",
    title: "《星辰大海》第二季正式官宣，原班人马回归",
    category: "剧集资讯",
    cover: "https://readdy.ai/api/search-image?query=a%20cinematic%20space%20station%20interior%20with%20blue%20lights%20and%20astronaut%20silhouette%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-02&orientation=landscape",
    summary: "备受好评的科幻剧集《星辰大海》宣布启动第二季制作，主创团队确认原班人马回归，故事将走向更辽阔的深空。",
    content: [
      "出品方今日正式宣布，人气科幻剧集《星辰大海》第二季已进入筹备阶段，第一季的主创团队与主要演员将悉数回归。",
      "据透露，第二季的故事将在此基础上进一步拓展世界观，把镜头伸向更遥远的深空，探讨人类与未知文明相遇后的命运。制作规格也将全面升级。",
      "第一季播出期间曾收获大量好评，其扎实的剧本与精良的视效被认为刷新了国产科幻剧的创作水准。第二季的官宣消息发布后，迅速登上社交平台热议榜单。",
    ],
    author: "麻豆剧集频道",
    publishedAt: "2026-10-12",
    tags: ["星辰大海", "科幻", "续订"],
    relatedMediaId: "tv-04",
  },
  {
    id: "news-03",
    title: "年度电影奖项提名名单揭晓，多部佳作入围",
    category: "行业动态",
    cover: "https://readdy.ai/api/search-image?query=a%20cinematic%20awards%20stage%20with%20golden%20spotlights%20and%20red%20carpet%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-03&orientation=landscape",
    summary: "本年度电影奖项提名名单正式公布，多部口碑佳作入围主要奖项，竞争异常激烈，颁奖典礼将于下月举行。",
    content: [
      "本年度电影奖项提名名单今日正式揭晓，多部在口碑与市场上表现亮眼的影片入围最佳影片、最佳导演等主要奖项。",
      "从提名分布来看，现实主义题材与类型化创作并重，既有聚焦普通人生活的温情之作，也有在视听语言上大胆创新的类型片。",
      "评委会表示，今年的入围作品整体水准较高，最终获奖结果将在下月举行的颁奖典礼上揭晓。",
    ],
    author: "麻豆影视观察",
    publishedAt: "2026-10-11",
    tags: ["奖项", "提名", "行业"],
    relatedMediaId: "movie-04",
  },
  {
    id: "news-04",
    title: "经典影片 4K 修复版重映，重温银幕经典",
    category: "经典回顾",
    cover: "https://readdy.ai/api/search-image?query=a%20vintage%20film%20reel%20projector%20with%20glowing%20light%20in%20a%20dark%20room%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-04&orientation=landscape",
    summary: "多部影史经典迎来 4K 修复重映，让新一代观众得以在大银幕上重温那些跨越时代的动人故事。",
    content: [
      "为致敬影史经典，多部具有里程碑意义的影片完成 4K 修复，并将在全国部分影院进行限量重映。",
      "修复团队对胶片进行了逐帧清理与色彩校正，在保留原作质感的同时，让画面细节与声音层次得到显著提升。",
      "不少影迷表示，能在影院重温这些经典作品，是一次难得的观影体验。相关场次开票后反响热烈。",
    ],
    author: "麻豆经典修复计划",
    publishedAt: "2026-10-09",
    tags: ["经典", "修复", "重映"],
    relatedMediaId: "movie-08",
  },
  {
    id: "news-05",
    title: "暑期档前瞻：多部商业大片蓄势待发",
    category: "行业动态",
    cover: "https://readdy.ai/api/search-image?query=a%20cinematic%20cinema%20lobby%20with%20colorful%20movie%20posters%20and%20glowing%20light%20boxes%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-05&orientation=landscape",
    summary: "随着暑期档临近，多部备受期待的商业大片陆续定档，涵盖动作、科幻、动画等类型，市场竞争趋于白热化。",
    content: [
      "随着暑期档临近，多家片方陆续公布定档消息，一批制作精良的商业大片将集中在未来两个月与观众见面。",
      "从已公布的片单来看，动作、科幻、动画三大类型占据了主要席位，不少影片在特效与制作规模上投入巨大。",
      "业内人士认为，暑期档历来是全年票房的重要战场，多部强片同档竞争，或将再次点燃观众的观影热情。",
    ],
    author: "麻豆影视观察",
    publishedAt: "2026-10-07",
    tags: ["暑期档", "定档", "前瞻"],
    relatedMediaId: "movie-11",
  },
  {
    id: "news-06",
    title: "《长安十二时》口碑爆棚，古装剧创作再攀高峰",
    category: "剧集资讯",
    cover: "https://readdy.ai/api/search-image?query=an%20ancient%20chinese%20city%20at%20night%20with%20glowing%20lanterns%20and%20soldiers%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-06&orientation=landscape",
    summary: "古装悬疑剧《长安十二时》播出后口碑一路走高，扎实的剧本与考究的服化道获得观众一致认可。",
    content: [
      "古装悬疑剧《长安十二时》自开播以来口碑持续走高，紧凑的叙事节奏与考究的历史细节成为观众讨论的焦点。",
      "剧中对古代都城生活的还原、对人物群像的细腻刻画，被认为是近年来古装题材创作的一次突破。",
      "主创团队表示，希望通过对历史的敬畏与对故事的打磨，让观众在追剧之余，也能感受到传统文化的魅力。",
    ],
    author: "麻豆剧集频道",
    publishedAt: "2026-10-06",
    tags: ["古装", "口碑", "长安十二时"],
    relatedMediaId: "tv-01",
  },
  {
    id: "news-07",
    title: "流媒体平台发布年度片单，原创内容持续加码",
    category: "行业动态",
    cover: "https://readdy.ai/api/search-image?query=a%20modern%20streaming%20platform%20interface%20on%20a%20large%20screen%20with%20movie%20thumbnails%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-07&orientation=landscape",
    summary: "多家流媒体平台陆续公布年度内容片单，原创剧集与电影投入持续加大，内容竞争进入新阶段。",
    content: [
      "多家流媒体平台近日相继公布年度内容片单，原创剧集与原创电影的数量较往年明显增加。",
      "平台方表示，将持续加大对优质原创内容的投入，通过多元化题材满足不同观众群体的观看需求。",
      "业内分析认为，随着观众审美水平的提升，内容质量正在成为平台竞争的核心，单纯依靠数量已难以取胜。",
    ],
    author: "麻豆影视观察",
    publishedAt: "2026-10-04",
    tags: ["流媒体", "片单", "原创"],
  },
  {
    id: "news-08",
    title: "《真相迷局》收官引爆讨论，悬疑剧迎来创作热潮",
    category: "剧集资讯",
    cover: "https://readdy.ai/api/search-image?query=a%20detective%20clue%20board%20with%20red%20strings%20and%20photos%20in%20a%20dim%20office%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-08&orientation=landscape",
    summary: "悬疑剧《真相迷局》迎来大结局，反转不断的剧情引发全网热议，悬疑题材的创作热度持续攀升。",
    content: [
      "悬疑剧《真相迷局》近日迎来大结局，层层反转的剧情在社交平台引发广泛讨论，相关话题多次登上热搜。",
      "该剧以严密的逻辑与扎实的人物塑造著称，被认为为代表近年悬疑题材创作水准的作品之一。",
      "随着该剧的收官，越来越多创作者开始关注悬疑题材，相关项目立项数量明显上升，类型剧市场竞争日趋激烈。",
    ],
    author: "麻豆剧集频道",
    publishedAt: "2026-10-03",
    tags: ["悬疑", "真相迷局", "结局"],
    relatedMediaId: "tv-09",
  },
  {
    id: "news-09",
    title: "专访《山海遗梦》导演：用东方美学讲好中国故事",
    category: "人物专访",
    cover: "https://readdy.ai/api/search-image?query=a%20director%20sitting%20in%20a%20warm%20studio%20surrounded%20by%20concept%20art%2C%20editorial%20portrait%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-09&orientation=landscape",
    summary: "《山海遗梦》导演在专访中分享创作理念，畅谈如何用现代影像语言诠释古典神话中的东方美学。",
    content: [
      "在近期热映的奇幻电影《山海遗梦》背后，导演许诺带领团队用了四年时间打磨剧本与视效，试图让古典神话在银幕上焕发新生。",
      "谈及创作初衷，许诺表示，团队希望用现代的影像语言，重新讲述那些流传千年的故事，让年轻观众也能感受到东方美学的魅力。",
      "对于未来，他透露下一部作品仍将扎根传统文化，但会在叙事与技术上尝试更多突破。",
    ],
    author: "麻豆人物",
    publishedAt: "2026-10-02",
    tags: ["专访", "山海遗梦", "导演"],
    relatedMediaId: "movie-03",
  },
  {
    id: "news-10",
    title: "影史经典回顾：那些定义了一个时代的电影",
    category: "经典回顾",
    cover: "https://readdy.ai/api/search-image?query=a%20row%20of%20classic%20movie%20posters%20hanging%20on%20a%20warm%20brick%20wall%20in%20a%20cinema%20lobby%2C%20editorial%20news%20photography%2C%20highly%20detailed&width=800&height=500&seq=madou-news-10&orientation=landscape",
    summary: "从叙事结构到视听语言，那些载入影史的经典作品，至今仍在深刻地影响着后来的电影人。",
    content: [
      "有些电影之所以被称为经典，不仅因为它们在诞生之时震撼了观众，更因为它们在数十年后依然被反复讨论与致敬。",
      "从镜头语言到叙事结构，从人物塑造到主题表达，这些作品为后来的创作者提供了丰富的养料，也不断拓宽着电影表达的边界。",
      "回顾影史，我们会发现真正打动人的，永远是那些关于人性、情感与命运的真挚表达，而技术只是让这种表达更有力量。",
    ],
    author: "麻豆经典修复计划",
    publishedAt: "2026-09-30",
    tags: ["影史", "经典", "回顾"],
    relatedMediaId: "movie-10",
  },
];